import { Component, Input } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';
import { JobQualificationsChangeTypeEnum } from '../../../enums/job-qualifications-change-type.enum';
import { JobQualificationChange } from '../../../models/job-qualification-change.model';
import { NullDashPipe } from 'src/app/shared/pipes/null-dash.pipe';
import { NgIf } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'nova-job-qualifications-years-of-exp-change',
    templateUrl: './job-qualifications-years-of-exp-change.component.html',
    styleUrls: ['./job-qualifications-years-of-exp-change.component.scss'],
    standalone: true,
    imports: [NgIf, NullDashPipe]
})
export class JobQualificationsYearsOfExpChangeComponent {
    @Input()
    change: JobQualificationChange<number>;

    @Input()
    noteChange?: JobQualificationChange<string>;

    changeType = JobQualificationsChangeTypeEnum;
}
